<i18n>
en:
  what:
    title: "What is TEBSTA ?"
    card1: "Leave your luggage<br>instead of a locker"
    card2: "Advance reservation<br>is possible"
    card3: "OK as many times<br>as you like"
    card4: "Easy settlement"
    text1: "It is safe even if there is no locker around because it can be deposited at a nearby shop."
    text2: "It is convenient because you can make a reservation in advance so you can use nearby places."
    text3: "It is free to put in and out so you do not forget to leave your luggage."
    text4: "Payment is completed automatically without cash."
  howto:
    title: "How to use TEBSTA"
    card1: "Find a store to store<br>your luggage"
    card2: "Leave your luggage<br>at the reserved shop"
    card3: "Receive the package<br>at the specified time"
    card4: "The automatic<br>decision is over"
ja:
  what:
    title: "TEBSTAってなに？？"
    card1: "ロッカー代わりに<br>荷物預り"
    card2: "事前予約ができる"
    card3: "何度でも荷物の<br>出し入れ可能"
    card4: "簡単決済"
    text1: "近くのお店に預けられるので<br>周りにロッカーが無くても<br>安心です"
    text2: "事前予約ができるので<br>近場を利用できて便利です"
    text3: "出し入れ自由だから<br>荷物の預け忘れなどが<br>ありません"
    text4: "キャッシュレスで<br>自動的に決済が完了します"
  howto:
    title: "TEBSTAの使い方"
    card1: "荷物を預けたい<br>お店を探す"
    card2: "予約したお店に<br>荷物を預ける"
    card3: "指定した時間に<br>荷物を受け取る"
    card4: "自動的に<br>決済完了"
cn:
  what:
    card1: "代替储物柜<br>离开你的行李"
    card2: "可以提前预订"
    card3: "任何次数<br>行李可以进出"
    card4: "易于结算"
  howto:
    card1: "我想离开我的行李<br>寻找店铺"
    card2: "到预定的商店<br>离开你的行李"
    card3: "在指定的时间<br>收到包裹"
    card4: "结算自动完成"
</i18n>

<template lang="pug">
  div.top
    //- トップ画像
    v-carousel(cycle hide-delimiters show-arrows-on-hover)
      v-carousel-item(v-for="(image, i) in images" :key="i" :src="image")

    //- 検索フォーム
    TopSearch

    //- TEBSTAの説明
    v-sheet.ma-5(tag="section")
      v-row
        v-col.pb-0(cols="12" align="center")
          h1|{{$t('what.title')}}
        v-col.pt-0(cols="12" align="center")
          v-img(src="@/assets/images/title-underline.png" width="227px" height="24px")
        v-col(cols="12" sm="6" md="3" align="center" v-for="i of 4" :key="i")
          v-card(elevation="0" width="240px")
            v-card-title.card-title.px-0
              v-row(algin="center")
                v-col(align="center")
                  div(v-html="$t(`what.card${i}`)")
            v-card-text(align="center")
              v-img(:src="require(`@/assets/images/top-what${i}.png`)" alt="Description image" width="148px" height="148px")
              p.mt-2(v-html="$t(`what.text${i}`)")

    //- 使い方
    v-sheet.ma-5(tag="section")
      v-row
        v-col.pb-0(cols="12" align="center")
          h1|{{$t('howto.title')}}
        v-col.pt-0(cols="12" align="center")
          v-img(src="@/assets/images/title-underline.png" width="227px" height="24px")
        v-col(cols="12" sm="6" md="3" align="center" v-for="i of 4" :key="i")
          v-card(elevation="0" width="240px")
            v-card-title.d-block.px-0(v-html="$t(`howto.card${i}`)")
            v-card-text(align="center")
              v-img(:src="require(`@/assets/images/top-howto${i}.png`)" alt="Description image" width="148px" height="148px")
</template>

<script>
import TopSearch from './TopSearch'

export default {
  components: {
    TopSearch
  },
  data () {
    return {
      // トップ画像リスト
      images: [
        require('@/assets/images/top0.png'),
        require('@/assets/images/top1.png')
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
.card-title
  box-sizing: border-box
  height: 96px
</style>
